module.exports = __webpack_public_path__ + "static/img/2025-7-02-2.77bf3382.png";